"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/** @jsx jsx */
var React = __importStar(require("react"));
var core_1 = require("@emotion/core");
var react_bootstrap_1 = require("react-bootstrap");
var Button_1 = __importDefault(require("../button/Button"));
exports.horizontalButtonPlacementStyling = function (theme) {
    return core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: absolute;\n        top: calc(50% - 18px);\n        width: 100%;\n    "], ["\n        position: absolute;\n        top: calc(50% - 18px);\n        width: 100%;\n    "])));
};
exports.rightButtonStyling = function (theme) {
    return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n       color: white;\n       border: none;\n       float: right;\n       text-shadow: 2px 2px 8px #000000;\n       &:hover{\n        color: white !important;\n       }\n       &:active{\n           color: white !important;\n       }\n    "], ["\n       color: white;\n       border: none;\n       float: right;\n       text-shadow: 2px 2px 8px #000000;\n       &:hover{\n        color: white !important;\n       }\n       &:active{\n           color: white !important;\n       }\n    "])));
};
exports.leftButtonStyling = function (theme) {
    return core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n       left: 20px;\n       color: white;\n       border: none;\n       text-shadow: 2px 2px 8px #000000;\n       &:hover{\n        color: white !important;\n       }\n       &:active{\n           color: white !important;\n       }\n    "], ["\n       left: 20px;\n       color: white;\n       border: none;\n       text-shadow: 2px 2px 8px #000000;\n       &:hover{\n        color: white !important;\n       }\n       &:active{\n           color: white !important;\n       }\n    "])));
};
exports.imageStyling = function (theme) {
    return core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n       height: 600px;\n       width: 100%;\n       object-fit: cover; \n    "], ["\n       height: 600px;\n       width: 100%;\n       object-fit: cover; \n    "])));
};
exports.imageContainer = function (theme) {
    return core_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n       height: 600px;\n       position: relative;\n    "], ["\n       height: 600px;\n       position: relative;\n    "])));
};
var ImageSlideShow = /** @class */ (function (_super) {
    __extends(ImageSlideShow, _super);
    function ImageSlideShow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentImage: { imageId: '', imagePath: '' },
            imageIndex: 0
        };
        return _this;
    }
    ImageSlideShow.prototype.componentDidMount = function () {
        this.setState({ currentImage: this.props.images[this.state.imageIndex] });
    };
    ImageSlideShow.prototype.prevImage = function () {
        var amountImages = this.props.images.length;
        var index = this.state.imageIndex;
        if (index === 0) {
            index = amountImages - 1;
        }
        else {
            index -= 1;
        }
        this.setState({ currentImage: this.props.images[index], imageIndex: index });
    };
    ImageSlideShow.prototype.nextImage = function () {
        var amountImages = this.props.images.length;
        var index = this.state.imageIndex;
        if (index === amountImages - 1) {
            index = 0;
        }
        else {
            index += 1;
        }
        this.setState({ currentImage: this.props.images[index], imageIndex: index });
    };
    ImageSlideShow.prototype.render = function () {
        var _this = this;
        return (core_1.jsx("div", { css: function (t) { return [_this.props.slideShowStyle !== undefined ? _this.props.slideShowStyle(t) : undefined]; } },
            core_1.jsx("div", { css: function (t) { return [exports.imageContainer(t)]; } },
                core_1.jsx(react_bootstrap_1.Image, { css: function (t) { return [exports.imageStyling(t)]; }, src: typeof this.state.currentImage.imagePath === 'string' ? this.state.currentImage.imagePath : '' }),
                core_1.jsx("div", { css: function (t) { return [exports.horizontalButtonPlacementStyling(t)]; } },
                    core_1.jsx(Button_1["default"], { onClick: this.prevImage.bind(this), buttonStyle: function (t) { return [exports.leftButtonStyling(t)]; } }, "\u276E"),
                    core_1.jsx(Button_1["default"], { onClick: this.nextImage.bind(this), buttonStyle: function (t) { return [exports.rightButtonStyling(t)]; } }, "\u276F")))));
    };
    return ImageSlideShow;
}(React.Component));
exports["default"] = ImageSlideShow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ImageSlideShow.js.map